function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.015 3.478V2.384c0-1.215-1.013-2.2-2.254-2.2-1.24 0-2.253.985-2.253 2.2v1.094H.76v4.039h6v-4.04h-.746zM2.27 2.384c0-.811.664-1.467 1.492-1.467.829 0 1.493.656 1.493 1.467v1.094H2.27V2.384z",
  fill: "#2E3439"
});

function SvgIconLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    fill: "none"
  }, props), _ref);
}

export default SvgIconLock;